// extracted by mini-css-extract-plugin
module.exports = {"buttons":"CancelAndSave_buttons__1vtSa"};